export { default as getPeopleActiveMenu } from './getPeopleActiveMenu';
